export const ADD_EMPLOYEE = 'addEmployee';
export const ADD_USER = 'addUser';
export const ADD_MORE_USER = 'addMoreUser';
export const SAVE_ADDITIONAL_EMPLOYEE_INFO = 'saveAdditionalEmployeeInfo';
export const DELETE_EMPLOYEE = 'deleteEmployee';
